
import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const CarParts = () => {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		api.get('/parts')
			.then(res => {
				if (mounted) {
					setItems(res.data.items || []);
					setError(null);
				}
			})
			.catch(err => {
				if (mounted) {
					setError(err.response?.data?.message || 'Алдаа гарлаа');
				}
			})
			.finally(() => {
				if (mounted) setLoading(false);
			});
		return () => { mounted = false; };
	}, []);

	if (loading) return <div style={{ padding: 32 }}>Уншиж байна...</div>;
	if (error) return <div style={{ padding: 32, color: 'red' }}>{error}</div>;

	return (
		<div style={{ padding: 32 }}>
			<h2>Сэлбэг, дагалдах</h2>
			{items.length === 0 ? (
				<div>Сэлбэг олдсонгүй.</div>
			) : (
				<ul style={{ listStyle: 'none', padding: 0 }}>
					{items.map((item, idx) => (
						<li key={item.id || idx} style={{ marginBottom: 16, border: '1px solid #eee', borderRadius: 8, padding: 16, background: '#fafbfc' }}>
							<div><strong>{item.name}</strong> — {item.category}</div>
							<div>Үнэ: {item.price}₮</div>
							<div>Үлдэгдэл: {item.stock}</div>
							{item.description && <div>Тайлбар: {item.description}</div>}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default CarParts;
